import { useCallback, useMemo, useState } from 'react'

import type { ExplorerClipboardEntry, ExplorerClipboardSource } from './clipboard'

export interface ExplorerClipboard {
  entry: ExplorerClipboardEntry | null
  copy: (entry: ExplorerClipboardSource) => void
  cut: (entry: ExplorerClipboardSource) => void
  clear: () => void
}

export function useExplorerClipboard(): ExplorerClipboard {
  const [entry, setEntry] = useState<ExplorerClipboardEntry | null>(null)
  const copy = useCallback((next: ExplorerClipboardSource) => {
    setEntry({ ...next, mode: 'copy' })
  }, [])
  const cut = useCallback((next: ExplorerClipboardSource) => {
    setEntry({ ...next, mode: 'cut' })
  }, [])
  const clear = useCallback(() => {
    setEntry(null)
  }, [])
  return useMemo(() => ({ entry, copy, cut, clear }), [entry, copy, cut, clear])
}
